import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-356d1d04"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "practice-bank" }
const _hoisted_2 = {
  key: 0,
  class: "mortgage-information"
}
const _hoisted_3 = { class: "info" }
const _hoisted_4 = { class: "information" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Current investments registered number", -1))
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "information" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Contributory mortgages number", -1))
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "button-row" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "general-accounts" }
const _hoisted_13 = { class: "table-top" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "__left" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Bank details"),
  /*#__PURE__*/_createElementVNode("h2", null, "Trust accounts")
], -1))
const _hoisted_15 = { class: "__right" }
const _hoisted_16 = { class: "ls-table" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = ["colspan"]
const _hoisted_19 = { key: 1 }
const _hoisted_20 = ["colspan"]
const _hoisted_21 = { key: 2 }
const _hoisted_22 = ["colspan"]
const _hoisted_23 = { "data-label": "BSB no." }
const _hoisted_24 = { "data-label": "Bank" }
const _hoisted_25 = { "data-label": "Branch" }
const _hoisted_26 = { "data-label": "Account no." }
const _hoisted_27 = { "data-label": "Account name" }
const _hoisted_28 = { "data-label": "Opened" }
const _hoisted_29 = { "data-label": "Closed" }
const _hoisted_30 = { "data-label": "Actions" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { class: "trust-accounts" }
const _hoisted_33 = { class: "table-top" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "__left" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Bank details"),
  /*#__PURE__*/_createElementVNode("h2", null, "General accounts")
], -1))
const _hoisted_35 = { class: "__right" }
const _hoisted_36 = { class: "between" }
const _hoisted_37 = { class: "information" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "General accounting system", -1))
const _hoisted_39 = { class: "ls-table" }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = ["colspan"]
const _hoisted_42 = { key: 1 }
const _hoisted_43 = ["colspan"]
const _hoisted_44 = { key: 2 }
const _hoisted_45 = ["colspan"]
const _hoisted_46 = { "data-label": "BSB no." }
const _hoisted_47 = { "data-label": "Bank" }
const _hoisted_48 = { "data-label": "Branch" }
const _hoisted_49 = { "data-label": "Account no." }
const _hoisted_50 = { "data-label": "Account name" }
const _hoisted_51 = { "data-label": "Opened" }
const _hoisted_52 = { "data-label": "Closed" }
const _hoisted_53 = { "data-label": "Actions" }
const _hoisted_54 = ["onClick"]

export function render(_ctx, _cache) {
  const _component_LoadingIndicator = _resolveComponent("LoadingIndicator")
  const _component_ErrorIndicator = _resolveComponent("ErrorIndicator")
  const _component_AddEditModal = _resolveComponent("AddEditModal")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_ctx.selectedPractice)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _withDirectives(_createElementVNode("input", {
                class: "narrow",
                disabled: !_ctx.isEditMortgageInfo,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.investmentsRegisteredNumber) = $event)),
                type: "text"
              }, null, 8, _hoisted_6), [
                [_vModelText, _ctx.investmentsRegisteredNumber]
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _withDirectives(_createElementVNode("input", {
                class: "narrow",
                disabled: !_ctx.isEditMortgageInfo,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.contributoryMortgagesNumber) = $event)),
                type: "text"
              }, null, 8, _hoisted_9), [
                [_vModelText, _ctx.contributoryMortgagesNumber]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            (_ctx.isSavingMortgageInfo)
              ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                  _createVNode(_component_LoadingIndicator, { loadingText: 'Saving ...' }, null, 8, ["loadingText"])
                ]))
              : _createCommentVNode("", true),
            (!_ctx.isEditMortgageInfo)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "btn btn-outline dark sml",
                  onClick: _cache[2] || (_cache[2] = $event => (_ctx.isEditMortgageInfo = true))
                }, "Edit"))
              : (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  class: "btn btn-primary sml",
                  onClick: _cache[3] || (_cache[3] = $event => (_ctx.saveMortgageInfo()))
                }, "Save"))
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("button", {
            class: "btn btn-primary",
            onClick: _cache[4] || (_cache[4] = $event => (_ctx.openAddEditAccount({id: 0, accountType: { id: 1}})))
          }, "Add trust account")
        ])
      ]),
      _createElementVNode("table", _hoisted_16, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.trustAccTableHeadings, (h, index) => {
              return (_openBlock(), _createElementBlock("th", null, [
                _createElementVNode("p", null, _toDisplayString(h.text), 1)
              ]))
            }), 256))
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_ctx.loadingContent)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_17, [
                _createElementVNode("td", {
                  colspan: _ctx.trustAccTableHeadings.length
                }, [
                  _createVNode(_component_LoadingIndicator)
                ], 8, _hoisted_18)
              ]))
            : (_ctx.errorLoadingContent)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_19, [
                  _createElementVNode("td", {
                    colspan: _ctx.trustAccTableHeadings.length
                  }, [
                    _createVNode(_component_ErrorIndicator)
                  ], 8, _hoisted_20)
                ]))
              : (!_ctx.loadingContent && !_ctx.errorLoadingContent && _ctx.trustAccounts.length == 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_21, [
                    _createElementVNode("td", {
                      colspan: _ctx.trustAccTableHeadings.length
                    }, "No Records", 8, _hoisted_22)
                  ]))
                : (!_ctx.loadingContent && !_ctx.errorLoadingContent && _ctx.trustAccounts.length > 0)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(_ctx.trustAccounts, (tA) => {
                      return (_openBlock(), _createElementBlock("tr", null, [
                        _createElementVNode("td", _hoisted_23, _toDisplayString(tA.bsbno), 1),
                        _createElementVNode("td", _hoisted_24, _toDisplayString(tA.bankName), 1),
                        _createElementVNode("td", _hoisted_25, _toDisplayString(tA.bankBranchName), 1),
                        _createElementVNode("td", _hoisted_26, _toDisplayString(tA.accountNo), 1),
                        _createElementVNode("td", _hoisted_27, _toDisplayString(tA.name), 1),
                        _createElementVNode("td", _hoisted_28, _toDisplayString(tA.dateOpened ? _ctx.$formatDate(tA.dateOpened) : ''), 1),
                        _createElementVNode("td", _hoisted_29, _toDisplayString(tA.dateClosed ? _ctx.$formatDate(tA.dateClosed) : ''), 1),
                        _createElementVNode("td", _hoisted_30, [
                          _createElementVNode("button", {
                            class: "btn btn-default sml ml-2",
                            onClick: $event => (_ctx.openAddEditAccount(tA))
                          }, "Edit", 8, _hoisted_31)
                        ])
                      ]))
                    }), 256))
                  : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_32, [
      _createElementVNode("div", _hoisted_33, [
        _hoisted_34,
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("button", {
            class: "btn btn-primary",
            onClick: _cache[5] || (_cache[5] = $event => (_ctx.openAddEditAccount({id: 0, accountType: { id: 2} })))
          }, "Add general account")
        ])
      ]),
      _createElementVNode("div", _hoisted_36, [
        _createElementVNode("div", _hoisted_37, [
          _hoisted_38,
          _createElementVNode("p", null, _toDisplayString(_ctx.selectedPractice.generalAccountingApp ? _ctx.selectedPractice.generalAccountingApp.name : 'N/A'), 1)
        ]),
        _createElementVNode("button", {
          class: "btn btn-outline dark sml mb-2",
          onClick: _cache[6] || (_cache[6] = $event => (_ctx.openAddEditAccount({})))
        }, "Edit")
      ]),
      _createElementVNode("table", _hoisted_39, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.generalAccTableHeadings, (h, index) => {
              return (_openBlock(), _createElementBlock("th", null, [
                _createElementVNode("p", null, _toDisplayString(h.text), 1)
              ]))
            }), 256))
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_ctx.loadingContent)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_40, [
                _createElementVNode("td", {
                  colspan: _ctx.generalAccTableHeadings.length
                }, [
                  _createVNode(_component_LoadingIndicator)
                ], 8, _hoisted_41)
              ]))
            : (_ctx.errorLoadingContent)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_42, [
                  _createElementVNode("td", {
                    colspan: _ctx.generalAccTableHeadings.length
                  }, [
                    _createVNode(_component_ErrorIndicator)
                  ], 8, _hoisted_43)
                ]))
              : (!_ctx.loadingContent && !_ctx.errorLoadingContent && _ctx.generalAccounts.length == 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_44, [
                    _createElementVNode("td", {
                      colspan: _ctx.generalAccTableHeadings.length
                    }, "No Records", 8, _hoisted_45)
                  ]))
                : (!_ctx.loadingContent && !_ctx.errorLoadingContent && _ctx.generalAccounts.length > 0)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(_ctx.generalAccounts, (gA) => {
                      return (_openBlock(), _createElementBlock("tr", null, [
                        _createElementVNode("td", _hoisted_46, _toDisplayString(gA.bsbno), 1),
                        _createElementVNode("td", _hoisted_47, _toDisplayString(gA.bankName), 1),
                        _createElementVNode("td", _hoisted_48, _toDisplayString(gA.bankBranchName), 1),
                        _createElementVNode("td", _hoisted_49, _toDisplayString(gA.accountNo), 1),
                        _createElementVNode("td", _hoisted_50, _toDisplayString(gA.name), 1),
                        _createElementVNode("td", _hoisted_51, _toDisplayString(gA.dateOpened ? _ctx.$formatDate(gA.dateOpened) : ''), 1),
                        _createElementVNode("td", _hoisted_52, _toDisplayString(gA.dateClosed ? _ctx.$formatDate(gA.dateClosed) : ''), 1),
                        _createElementVNode("td", _hoisted_53, [
                          _createElementVNode("button", {
                            class: "btn btn-default sml ml-1",
                            onClick: $event => (_ctx.openAddEditAccount(gA))
                          }, "Edit", 8, _hoisted_54)
                        ])
                      ]))
                    }), 256))
                  : _createCommentVNode("", true)
        ])
      ])
    ]),
    (_ctx.showAddEditModal)
      ? (_openBlock(), _createBlock(_component_AddEditModal, {
          key: 1,
          onCloseModal: _cache[7] || (_cache[7] = $event => (_ctx.closeAddEditAccount())),
          bankAcct: _ctx.selectedAccount
        }, null, 8, ["bankAcct"]))
      : _createCommentVNode("", true)
  ]))
}